import React from "react";

function SectionBody({ className }) {
  return (
    <div className={className}>
      <p>
        Whether we teach math or not, the way we talk about math matters. Those
        of us who have had difficult experiences can be tempted to say things
        like, "I'm not a math person" &ndash; and we may not realize we're
        impacting the way our students see themselves, too.
      </p>
      <p>
        It's powerful when our students hear us identify as pattern seekers,
        collaborators, and problem-solvers. It's powerful when they see us use
        math every day. It's powerful when we remind them that mistakes are more
        than just "OK": They are a critical part of learning.
      </p>
      <p className="bolded-text-body">
        Are you committed to sending your students the message that there's no
        limit to what they can achieve in math? Share a custom graphic on social
        media and in your school community!
      </p>
      <p>&mdash;Teacher Cicely Woodard</p>
    </div>
  );
}

export default SectionBody;
